export const APPS_CONNECT_OPEN = 'apps:connect-open';

export interface AppsConnectOpenDetail {
  provider?: string;
  tab?: 'connected' | 'add';
}

export function openAppConnectHub(detail: AppsConnectOpenDetail = {}): void {
  window.dispatchEvent(new CustomEvent(APPS_CONNECT_OPEN, { detail }));
}
